(function () {
    'use strict';

    angular
        .module('app.sso')
        .controller('LogoutController', LogoutController);

    /* @ngInject */
    function LogoutController(
        ATAC,
        logger,
        config,
        $location,
        ssoService,
        applicationService,
        $window) {

        //Private Variables
        var vm = this;

        //Public Variables
        vm.userProfile = null;
        vm.applications = [];
        vm.loggedout = false;
        vm.loaded = false;

        //Public Methods
        vm.applicationloggedOut = applicationloggedOut;
        vm.logUserOut = logUserOut;

        //Activate Controller
        activate();

        function activate() {
            getLogOutApplications();
            logger.info('Activated SSO Logout View');
        }

        function getLogOutApplications() {
            return applicationService.getApplicationsForLogOut()
                   .then(function (result) {
                       logger.log('Applications For Log Out', result);
                       if (result.length > 0) {
                           angular.forEach(result, function (application) {
                                   application.complete = false;
                           });
                           vm.applications = result;
                       }
                       vm.loaded = true;
                       // If we didn't receive any clients, just logout immediately.
                       if (vm.loaded && (vm.applications === null || vm.applications.length === 0)) {
                           logUserOut();
                       }
                   });
        }

        function applicationloggedOut() {
            if (vm.loaded && !vm.loggedout) {
                var loggedout = true;
                angular.forEach(vm.applications, function (application) {
                    if (!application.complete) {
                        loggedout = false;
                    }
                });
                vm.loggedout = loggedout;
            }

            // If we didn't receive any clients, just logout immediately.
            if (vm.loaded && vm.loggedout) {
                vm.logUserOut();
            }
        }

        function logUserOut() {
            var returnURL = ($location.search()).returnURL;
            if (!!returnURL){
                returnURL = returnURL.replace(new RegExp('~2F', 'g'), '/');
            }

            if (!returnURL) {
                if (typeof location.origin === 'undefined') {
                    location.origin = location.protocol + '//' + location.host;
                }
                returnURL = location.origin;
            }
            //log out of SSO.
            $window.location = 'https://' + config.auth0Domain + '/v2/logout?returnTo=' + encodeURIComponent(returnURL);
        }
    }
})();
